module.exports = __webpack_public_path__ + "static/banner-two-shape4-bea87edd53f303434089be37f1de712f.png";